import { render, staticRenderFns } from "./customergroup.vue?vue&type=template&id=2745725e"
import script from "./customergroup.vue?vue&type=script&lang=js"
export * from "./customergroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports